<template>
  <main class="preview">
    <Header>
      <router-link
        :to="{ name: 'editor' }"
        class="header__action"
      >
        <IconArrow direction="left" />
        Voltar para o editor
      </router-link>
      <div class="header__page-title">
        <span>{{ activePage.title }}</span>
        <IconLanguage
          v-if="hasTranslations"
          :language="activePage.language"
        />
      </div>
      <a
        :href="activePage.previewUrl"
        target="_blank"
        class="preview__icon header__action"
      >
        <IconDesktop size="xs" />
        Desktop
      </a>
    </Header>
    <div
      id="wrapper"
      class="preview__wrapper"
      :class="`preview__wrapper--${preview}`"
    >
      <iframe :src="iframeSrc"></iframe>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from '@/components/Header.vue';
import IconArrow from '@/components/icons/IconArrow.vue';
import IconLanguage from '@/components/icons/IconLanguage.vue';
import IconDesktop from '@/components/icons/IconDesktop.vue';

export default {
  name: 'Preview',
  components: {
    Header,
    IconArrow,
    IconLanguage,
    IconDesktop,
  },
  data() {
    return {
      preview: 'phone',
    };
  },
  computed: {
    hasTranslations() {
      return (
        this.activePage.translationIds && this.activePage.translationIds.length
      );
    },
    iframeSrc() {
      const hash = this.$route.query.hash || '';
      const { preview } = this;

      return this.$router.resolve({
        name: 'preview-iframe',
        query: { preview },
        hash,
      }).href;
    },
    publishedUrlLink() {
      const { language, urlPath } = this.activePage;
      const isHome = urlPath === '_';
      const isTranslation = language && language !== 'pt';
      const path = isHome ? '' : urlPath;

      return isTranslation
        ? `${this.siteHostname}/${language}/${path}`
        : `${this.siteHostname}/${path}`;
    },
    ...mapGetters(['activePage', 'siteHostname']),
  },
  mounted() {
    document.body.classList.add('no-scroll');
  },
};
</script>

<style scoped lang="scss">
.preview {
  &__icon {
    flex-direction: column;
    font-size: 11px;
  }

  &__wrapper {
    @include media-breakpoint-down(lg) {
      transform: scale(0.8, 0.8);
    }

    @include media-breakpoint-down(md) {
      transform: scale(0.6, 0.6);
    }

    @include media-breakpoint-down(sm) {
      transform: scale(0.4, 0.4);
    }

    iframe {
      display: block;
      border: 0;
      width: 100%;
    }

    &--desktop {
      iframe {
        height: calc(100vh - 45px); // minus header height
      }
    }

    &--phone {
      width: 360px;
      height: 710px;
      border: 15px solid $lb-black;
      border-radius: 40px;
      margin: -60px auto;
      overflow: hidden;
      transform: scale(0.7, 0.7);
      transition: all 0.5s ease;
      animation: fadein 2s;

      @include media-breakpoint-down(md) {
        margin: 0 0 0 -70px;
      }

      iframe {
        height: 100%;
        background-color: $lb-black;
      }
    }
  }
}
</style>
